module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/area_eight-cc849e9232937ad351337d21b693e6d4.jpg";